import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { db } from '@/shared/firebase'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    catalog: {},
    orders: [],
    ordersLoaded: false,
    organizations: [],
    organizationsLoaded: false,
    products: [],
    productsLoaded: false,
    purchase: {},
    purchaseLoaded: false,
    shelves: [],
    shelvesLoaded: false
  },
  actions: {
    bindAssets: firestoreAction(({ bindFirestoreRef, commit }) => {
      bindFirestoreRef('catalog', db.doc(`static/catalog`))
      bindFirestoreRef('orders', db.collection(`orders`).where('state', '==', 'preparing')).then(() => {
        commit('loadedState', { type: 'orders', isLoaded: true })
      })
      bindFirestoreRef('organizations', db.collection(`organizations`).where('demo', '==', false)).then(() => {
        commit('loadedState', { type: 'organizations', isLoaded: true })
      })
      bindFirestoreRef('products', db.collection(`static/catalog/products`)).then(() => {
        commit('loadedState', { type: 'products', isLoaded: true })
      })
      bindFirestoreRef('purchase', db.doc(`private/purchase`)).then(() => {
        commit('loadedState', { type: 'purchase', isLoaded: true })
      })
      bindFirestoreRef('shelves', db.collection(`private/warehouse/shelves`)).then(() => {
        commit('loadedState', { type: 'shelves', isLoaded: true })
      })
      return true
    }),
    unbindAssets: firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('catalog')
      unbindFirestoreRef('orders')
      unbindFirestoreRef('organizations')
      unbindFirestoreRef('products')
      unbindFirestoreRef('shelves')
      return true
    })
  },
  getters: {
    stockByProductId: state => {
      return productId => {
        let spaces = {}
        let itemsInStock = []
        state.shelves.forEach(shelf => {
          Object.keys(shelf.spaces).forEach(spaceId => {
            spaces[`${shelf.id}${spaceId}`] = { items: _.cloneDeep(shelf.spaces[spaceId].items) }
          })
        })
        spaces = _.pickBy(spaces, { items: [{ productId: productId }] })
        Object.keys(spaces).forEach(spaceId => {
          spaces[spaceId].items = _.pickBy(spaces[spaceId].items, { productId: productId })
          Object.keys(spaces[spaceId].items).forEach(itemKey => {
            itemsInStock.push({ spaceId, ...spaces[spaceId].items[itemKey] })
          })
        })
        return itemsInStock
      }
    },
    productsOutOfStock: state => {
      const orders = state.orders
      const products = {}
      orders.forEach(order => {
        order.residents.forEach(resident => {
          resident.shoppingList.items.forEach(item => {
            const oldNeed = products[item.productId] ? products[item.productId].need : 0
            products[item.productId] = {
              need: oldNeed + item.amount
            }
          })
        })
      })
      return _.isEmpty(products) ? null : products
    },
    organizationName: state => {
      return organizationId => {
        return _.find(state.organizations, { id: organizationId }).name
      }
    }
  },
  mutations: {
    loadedState(state, options) {
      const { type, isLoaded } = options
      state[`${type}Loaded`] = isLoaded
    },
    ...vuexfireMutations
  },
  modules: {}
})
